import React from "react";
import { useStore } from "react-redux";
import { BERATER_KENNZEICHEN } from "../../utils/enums";
import { formatCurrency } from "../../utils/functions";

export const SortenSumme = (props) => {
  const { beraterFeld } = props || {};
  const { configStorage, basketStorage } = useStore().getState();

  const direktbestellung = basketStorage.doShip !== "no";
  const warenkorb = basketStorage.orderDataForOrder ? basketStorage.orderDataForOrder.sortenWarenkorb || {} : {};
  const selectedFiliale = basketStorage.selectedFiliale;

  // display positive values
  let gebuehren = Number(warenkorb.gebuehren);

  //  Für jeden Artikel fallen spezifische Gebühren an.
  let gesamtProvision = basketStorage.getEnthalteneProvision().getPrice();

  return (
    <div className="row justify-content-end mb-three">
      <div className="col-12 col-md-10 col-lg-8 float-end table-scroll">
        <table className="table table-bordered table-responsive-xs fs-5 text-end">
          <tbody>
            <tr>
              <th className="active">Gegenwert netto:</th>
              <td className="text-end">
                {formatCurrency(warenkorb.netto)}
              </td>
            </tr>
            {
              configStorage.getBeraterKennzeichen() !== BERATER_KENNZEICHEN.KEIN_BERATERKENNZEICHEN &&
                beraterFeld === "J"
                ? <tr>
                  <th className="active">davon Provisionen:</th>
                  <td className="text-end">
                    {formatCurrency(gesamtProvision)}
                  </td>
                </tr>
                : null
            }
            <tr>
              <th className="active">Versandkosten:</th>
              <td className="text-end">
                {formatCurrency(warenkorb.versandkosten)}
              </td>
            </tr>
            <tr>
              <th className="active">Konditions&shy;änderungen/Gebühren:</th>
              <td className="text-end">
                {formatCurrency(gebuehren)}
              </td>
            </tr>
            <tr className="fw-bold">
              <th className="active">
                Endsumme:
              </th>
              <td className="text-end">
                {formatCurrency(warenkorb.summe)}
              </td>
            </tr>
            {
              (
                !direktbestellung &&
                selectedFiliale &&
                !configStorage.isAnkaufShop()
              )
                ? (
                  <tr>
                    <th className="active">Filiale</th>
                    <td>
                      {(selectedFiliale || {}).name}
                    </td>
                  </tr>
                )
                : null
            }
          </tbody>
        </table>
      </div>
    </div>
  );
};
